module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "cebianlan"
  }, [_c('div', {
    staticClass: "inner-warp"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title) + "\n      "), _c('a', {
    attrs: {
      "href": "#/index/aside"
    },
    on: {
      "click": function($event) {
        _vm.goback(false)
      }
    }
  }, [_vm._v("查看公证处")])]), _vm._v(" "), _c('div', {
    staticClass: "number-title"
  }, _vm._l((_vm.theTitle), function(item, index) {
    return _c('div', {
      staticClass: "list"
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('i', [_vm._v(_vm._s(item.number))])])
  })), _vm._v(" "), _c('ul', {
    directives: [{
      name: "iscroll",
      rawName: "v-iscroll"
    }],
    staticClass: "place-number-warp"
  }, [_c('div', {
    staticClass: "warp-box"
  }, _vm._l((_vm.zoneList), function(item, index) {
    return _c('li', {
      staticClass: "list",
      on: {
        "click": function($event) {
          _vm.hoverCityOut(index)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(item.number))])]), _vm._v(" "), _c('ol', {
      staticClass: "inner-list",
      class: {
        active: item.swite
      }
    }, _vm._l((item.list), function(inerItem, inerIndex) {
      return _c('li', {
        on: {
          "click": function($event) {
            _vm.goback(false)
          }
        }
      }, [_c('a', {
        attrs: {
          "href": "#/index/people"
        }
      }, [_vm._v("\n                " + _vm._s(inerItem.name) + "\n                "), _c('i', [_vm._v(_vm._s(inerItem.state))])])])
    }))])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be8f8570"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aside-people.vue
// module id = 184
// module chunks = 1